import { hasProp } from './props.js';
export const paramsRegexDefault = /:([a-z_.]+)/gi;
export const paramsMustache = /\{\{([a-z_.]+)}}/gi;
export function paramsReplacer(str, params, paramsRegex = paramsRegexDefault) {
    try {
        return str.replace(paramsRegex, (m, p1) => {
            let target = params;
            for (const p of p1.split('.')) {
                if (typeof target[p] === 'object') {
                    target = target[p];
                }
                if (hasProp(target, p)) {
                    return target[p];
                }
            }
            return m;
        });
    }
    catch (e) {
        return '';
    }
}
export function mustache(str, params) {
    return paramsReplacer(str, params, paramsMustache);
}
//# sourceMappingURL=params.js.map